import * as React from "react";
import { SVGProps } from "react";
const SvgNoAccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={131}
    height={132}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#no-access_svg__a)">
      <circle cx={65.5} cy={61} r={47.5} fill="#FF5757" />
    </g>
    <path
      d="M65.5 42.208a10.228 10.228 0 0 0-10.25 10.25v1.708a3.427 3.427 0 0 0-3.417 3.417v17.083a3.427 3.427 0 0 0 3.417 3.417h20.5a3.427 3.427 0 0 0 3.416-3.417V57.583a3.427 3.427 0 0 0-3.416-3.417v-1.708c0-5.678-4.572-10.25-10.25-10.25Zm0 3.417c3.888 0 6.833 2.944 6.833 6.833v1.708H58.666v-1.708c0-3.889 2.945-6.833 6.834-6.833Zm0 17.083a3.427 3.427 0 0 1 3.416 3.417A3.427 3.427 0 0 1 65.5 69.54a3.427 3.427 0 0 1-3.417-3.416 3.427 3.427 0 0 1 3.417-3.417Z"
      fill="#fff"
    />
    <defs>
      <filter
        id="no-access_svg__a"
        x={0}
        y={0.5}
        width={131}
        height={131}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={9} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11468_316298"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11468_316298"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgNoAccess;
